// src/components/ui/StatusBadge.tsx

import React from 'react';
import { PackageStatus, PACKAGE_STATUS_LABELS, PACKAGE_STATUS_COLORS } from '../../types/package.types';

interface Props { status: PackageStatus; }

export const StatusBadge: React.FC<Props> = ({ status }) => {
  const color = PACKAGE_STATUS_COLORS[status] ?? '#6b7280';
  const label = PACKAGE_STATUS_LABELS[status] ?? status;

  return (
    <span
      className="status-badge"
      style={{
        backgroundColor: `${color}22`,
        color,
        borderColor: `${color}55`,
      }}
    >
      {label}
    </span>
  );
};
